<div class="content-header">Activity</div>
<div class="content-with-elevation content" style="margin-top: 16px;">
  <div class="grid-x">
    <div class="cell large-12 small-12 medium-12">
      <div class="full-table">
        <lib-audit-log-individual-section [auditLog]="log" *ngFor="let log of auditLog"  [tldName]="domainName"></lib-audit-log-individual-section>
      </div>
    </div>
  </div>
</div>

